import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useNavigateWithQuery } from '../../shared/providers/index.js';
import { RouterSelectors, Selectors, useVerifyEmailMutation } from '../../store/index.js';

const VerifyEmail: FC = () => {
    const navigate = useNavigateWithQuery();
    const [verifyEmail] = useVerifyEmailMutation();
    const emailAction = useSelector(RouterSelectors.emailAction);
    const { oobCode } = emailAction;
    const user = useSelector(Selectors.user);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        verifyEmail({ code: oobCode }).then((result: any) => {
            if (result) {
                setSuccess(true);
            } else {
                setError(true);
            }
        });
    }, []);

    const navigateAway = (path: string) => (evt) => {
        evt.preventDefault();
        navigate(path, {
            emailAction: {
                mode: '',
                oobCode: '',
                apiKey: '',
                continueUrl: '',
            },
        });
    };

    if (success) {
        return (
            <div className="p-3">
                <div className="alert alert-success">
                    Your email has been verified.{' '}
                    {user ? (
                        <span>
                            <a href="/playbook/personal" onClick={navigateAway('/playbook/personal')}>
                                Click here
                            </a>{' '}
                            to return to your playbook.
                        </span>
                    ) : (
                        <span>
                            <a href="/login" onClick={navigateAway('/login')}>
                                Click here
                            </a>{' '}
                            to login.
                        </span>
                    )}
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-3">
                <div className="alert alert-danger">This link is invalid or expired.</div>
            </div>
        );
    }

    return null;
};

export default VerifyEmail;
